import { useHistory } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import Appointment from '../../appointment/Appointment';
import SelectPatientModal from './SelectPatientModal';
import PrescriptionModal from '../../../../components/authorised/prescriptions/PrescriptionModal';
import SelectPrescriptionProvider from '../../../../components/authorised/prescriptions/SelectPrescriptionProvider';
import AddActionDropdown from './AddActionDropdown';
import { currentUserUpdate } from '../../../../itrust_common/redux/actions/authActions';
import PatientFullMode from './PatientFullMode';

function MoreActionModals(props) {
  const { quickAction, quickActionEnable, appointmentEdit, editing, selected_patient_id, isPdf } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const pathname = history.location.pathname

  const handleUpdateQuickActions = (data) => {
    dispatch(currentUserUpdate(data, { include: ['address'] }))
  }

  return (
    <>
      {!isPdf && <SelectPatientModal />}
      {/* For quick action appointments + Dashboard edit appointment modal render*/}
      {((quickAction.select_patient_modal == 'appointment' || appointmentEdit?.id) && pathname !== '/appointment') && <Appointment isQuickAction={quickAction.select_patient_modal == 'appointment'} />}
      {quickAction.select_patient_modal == 'prescription' && <>
        <SelectPrescriptionProvider />
      </>}
      {(editing.patient_id || (pathname.includes('/report') && selected_patient_id)) && <PrescriptionModal />}
      {quickActionEnable && <AddActionDropdown onSubmit={handleUpdateQuickActions} />}
      {['patient', 'order', 'exam'].includes(quickAction.select_patient_modal) && <PatientFullMode patient={quickAction.patient} />}
    </>
  )
}

const mapStateToProps = (state) => {
  const { dashboard: { quickAction }, auth, appointment, reports } = state
  return {
    quickAction,
    selected_patient_id: quickAction.selected_patient_id,
    editing: reports.editing,
    quickActionEnable: auth.user?.preferences?.accessibility?.quick_actions,
    appointmentEdit: appointment.editing
  }
}

export default connect(mapStateToProps)(MoreActionModals)
